import { useState } from 'react';
import { Paper, useTheme } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { LoanDetailDrawer } from './LoanDetailDrawer';
import { useTranslation } from 'react-i18next';
import { resellerStatusPerLoanType } from '../utils';

function LoanDetailDrawerWrapper({ open, handleClose, application, addNewChatRecord, rejectApplication }) {
    const [priority, setPriority] = useState(application.enquiry_details.priority);
    return (
        <LoanDetailDrawer
            open={open}
            handleClose={handleClose}
            initialData={application}
            propTypes={priority}
            priority={priority}
            setPriority={setPriority}
            showSupportChat={
                !['unserviceable', 'cancelled'].includes(
                    application.enquiry_details.application_submission_status
                )
            }
            addNewChatRecord={addNewChatRecord}
            rejectApplication={rejectApplication}
        />
    );
}

export default function LoanTable({ applications = [], allStatus, currentStatusCode, addNewChatRecord, rejectApplication }) {
    const theme = useTheme();
    const { t, i18n } = useTranslation();

    const [rowIndexModal, setRowIndexModal] = useState(null);
    const [open, setOpen] = useState(false);

    const getRow = (srNo, application) => {
        const enquiry_details = application.enquiry_details;
        const data = {
            id: enquiry_details.id,
            's_no': srNo,
            'dashboard.application.business_name': enquiry_details.business_name ?? '-',
            'dashboard.application.applicant_name': `${enquiry_details.first_name ?? '-'} ${enquiry_details.last_name ?? '-'}`,
            'whatsapp_number': enquiry_details.whatsapp_number,
            'dashboard.application.status': (allStatus ?? (
                application.loan_type?.code
                    ? resellerStatusPerLoanType[application.loan_type.code]['all'](application.current_status_code)
                    : resellerStatusPerLoanType["null"]?.in_progress
            ))[currentStatusCode ?? application.current_status_code].label[i18n.language],
            'dashboard.application.loan_type': application.loan_type.name,
            'dashboard.application.expected_loan_amount': enquiry_details.required_loan_amount ?? '-',
            'dashboard.application.expected_emi_amount': enquiry_details.comfortable_emi_amount ?? '-',
        };

        if (application.latest_status === "OPTLAP10") {
            const inprinciple = application.inprinciple_detail;
            data['dashboard.application.inprinciple_loan_amount'] = inprinciple.sanction_loan_amount;
            data['dashboard.application.inprinciple_emi'] = inprinciple.sanction_emi_amount;
            data['dashboard.application.tenure'] = inprinciple.sanction_tenure;
            data['dashboard.application.business_pincode'] = enquiry_details.business_pincode;
        }
        return data;
    };

    const rows = applications.map((application, i) => getRow(i + 1, application));

    const columns = Object.keys(rows[0] ?? {}).map((key) => key !== 'id' && ({
        field: key,
        headerName: t(key),
        ...(key === 'S No.' ? { width: 50 } : { flex: 1 }),
        sortable: false,
    })).filter(Boolean);

    const handleRowClick = (param) => {
        // Find the index of the clicked row by its 'id'
        const rowIndex = rows.findIndex((row) => row.id === param.row.id);
        setRowIndexModal(rowIndex);
        setOpen(true);
    };

    return (
        <Paper
            sx={{
                width: '100%',
                height: '100%',
            }}
        >
            {applications[rowIndexModal] && (
                <LoanDetailDrawerWrapper
                    key={applications[rowIndexModal]?.enquiry_details.id}
                    open={open}
                    handleClose={() => setOpen(false)}
                    application={applications[rowIndexModal]}
                    addNewChatRecord={(chat) => addNewChatRecord(chat, rowIndexModal)}
                    rejectApplication={rejectApplication}
                />
            )}
            <DataGrid
                rows={rows}
                columns={columns}
                onRowClick={handleRowClick}
                // slots={{
                //     toolbar: GridToolbar,
                // }}
                sx={{
                    '& .MuiDataGrid-columnHeaders, .MuiDataGrid-row': {
                        borderBottom: `1px solid ${theme.palette.grey[300]}`,
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                        fontWeight: 'bold',
                    },
                }}
            />
        </Paper>
    );
}
